import { getRoomInfo } from '../../global/blocs/roomInfo'
import {
  getSpeakersInfo,
  type Speaker,
  useSpeakersQuery,
} from '../../sharedLegacy/hooks/useSpeakersQuery'
import { isExternalFeedConnectionType } from '../../global/blocs/useConnectInfo'
import { useLocalParticipant } from '../../webrtc/webRTCRoom'

const useIsLocalGuestSpeaker = () => {
  const { data: speakers } = useSpeakersQuery()
  const roomInfo = getRoomInfo()
  const isPresenter = roomInfo.role === 'presenter'

  return (
    isPresenter &&
    speakers?.find((speaker) => speaker.id === roomInfo.speakerId)
      ?.creationSource === 'guest'
  )
}

const useGetFeedSpeakers = () => {
  const { data: speakers } = useSpeakersQuery()

  const feedSpeakers = speakers
    ?.filter((speaker) => isExternalFeedConnectionType(speaker.connectionType))
    .reduce(
      (acc, speaker) => {
        acc[speaker.id] = speaker
        return acc
      },
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
      {} as Record<string, Speaker>
    )

  return feedSpeakers
}

const useIsFeed = (participantId: number) => {
  const feedSpeakers = useGetFeedSpeakers()

  // headless
  if (participantId === 0) return false

  return !!feedSpeakers?.[participantId]
}

const isExternalFeed = async (participantId: number) => {
  if (participantId === 0) return false
  try {
    const speaker = (await getSpeakersInfo()).find(
      (el) => el.id === participantId
    )
    if (!speaker) return false

    return isExternalFeedConnectionType(speaker.connectionType)
  } catch (e) {
    console.error('Error fetching speakers info', e)
  }

  return false
}

const useIsExternalFeed = (participantId?: number) => {
  const { data: speakers } = useSpeakersQuery()

  if (!participantId || participantId === 0) return false

  try {
    const speaker = speakers?.find((el) => el.id === participantId)
    if (!speaker) return false

    return isExternalFeedConnectionType(speaker.connectionType)
  } catch (e) {
    console.error('Error fetching speakers info', e)
  }

  return false
}

const useIsLocalFeed = () => {
  const participant = useLocalParticipant()
  return useIsExternalFeed(participant?.id)
}

export {
  useIsLocalGuestSpeaker,
  useGetFeedSpeakers,
  useIsFeed,
  isExternalFeed,
  useIsLocalFeed,
  useIsExternalFeed,
}
